import { FieldWrapper } from "components/ui/FieldWrapper";
import { RadioGroup, type RadioGroupProps } from "components/ui/RadioGroup";
import {
  type Control,
  type FieldPath,
  type FieldValues,
  useController,
} from "react-hook-form";

export type RhfRadioGroupProps<T extends FieldValues> = {
  name: FieldPath<T>;
  control?: Control<T>;
  label?: string;
  required?: boolean;
  hint?: string;
} & Omit<RadioGroupProps, "name" | "value" | "onChange" | "onBlur">;

/**
 * React Hook Form アダプタ for RadioGroup。
 * @param {RhfRadioGroupProps<T>} props RhfRadioGroup の props
 * @return {JSX.Element} FieldWrapper で包まれた RadioGroup
 */
export function RhfRadioGroup<T extends FieldValues>({
  name,
  control,
  label,
  required,
  hint,
  ...radioProps
}: RhfRadioGroupProps<T>): JSX.Element {
  const { field, fieldState } = useController<T>({ name, control });

  return (
    <FieldWrapper
      label={label}
      required={required}
      hint={hint}
      error={fieldState.error?.message}
    >
      <RadioGroup
        {...radioProps}
        name={field.name}
        value={field.value ?? ""}
        onChange={field.onChange}
        onBlur={field.onBlur}
        ref={field.ref}
      />
    </FieldWrapper>
  );
}
